import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from '../../form/Select';

import { useShiftTypesByFacilityQuery } from '../../../redux/external-agency';

import './ShowCredentialsByFacilityModal.scss';

const CustomSingleValue = ({ data }) => {
	return <div>{data.value}</div>;
};

const ShowCredentialsByFacilityModal = ({ onClose, selectedValue }) => {
	const [shiftTypeValue, setShiftTypeValue] = useState(selectedValue);
	const [showErrorMsg, setShowErrorMsg] = useState(false);

	const { data: shiftStructures } = useShiftTypesByFacilityQuery(undefined, {
		refetchOnMountOrArgChange: true
	});

	const handleSubmit = () => {
		if (!shiftTypeValue) {
			setShowErrorMsg(true);
		} else {
			setShowErrorMsg(false);
			const selectedOptionContainer = shiftStructures.find((elem) =>
				elem.options.find((el) => el.value === shiftTypeValue)
			);
			const selectedOptions = selectedOptionContainer?.options;
			const selectedOption = selectedOptions.find((elem) => elem.value === shiftTypeValue);
			const savedDropdownInfo = {};
			savedDropdownInfo.shiftType = selectedOption?.resourceType;
			savedDropdownInfo.specialtyType = selectedOption?.specialtyCode;
			savedDropdownInfo.facilityId = selectedOptionContainer?.facilityId;
			savedDropdownInfo.facilityName = selectedOptionContainer?.label;
			onClose(savedDropdownInfo, shiftTypeValue);
		}
	};

	const handleChange = (selected) => {
		if (selected?.shiftTypeValue) {
			setShowErrorMsg(false);
			setShiftTypeValue(selected.shiftTypeValue);
		}
	};

	return (
		<Modal show centered className="view-credentials-modal" backdrop="static" onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title> View credentials by facility</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<div className="modal-container">
					<div className="form-field">
						<Select
							handleChange={handleChange}
							options={shiftStructures}
							name="shiftTypeValue"
							defaultValue={{ value: selectedValue }}
							value={shiftTypeValue}
							placeholder="Select a shift type at a facility"
							className="form-select"
							isSearchable
							customComponents={{ SingleValue: CustomSingleValue }}
						/>
						{showErrorMsg && <div className="error-message">Please make a selection</div>}
					</div>
					<div className="info-text">
						Selecting a shift type at a facility allows you to view the requirements your professional will need to work
						those shifts.
					</div>
				</div>
			</Modal.Body>

			<Modal.Footer>
				<div className="buttons">
					<button type="button" className="btn-purple__text" onClick={onClose}>
						Cancel
					</button>
					<button type="button" className="btn-purple" onClick={handleSubmit}>
						View credentials
					</button>
				</div>
			</Modal.Footer>
		</Modal>
	);
};

export default ShowCredentialsByFacilityModal;
